import { render, staticRenderFns } from "./QArrowBox.vue?vue&type=template&id=2a343240&scoped=true"
import script from "./QArrowBox.vue?vue&type=script&lang=js"
export * from "./QArrowBox.vue?vue&type=script&lang=js"
import style0 from "./QArrowBox.vue?vue&type=style&index=0&id=2a343240&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a343240",
  null
  
)

export default component.exports